<template>
    <div class="uta-lang">
        <div class="uta-lang__desktop">
            <div class="uta-lang__current" @click="showLangList = !showLangList">
                <img class="uta-lang__current-flag" :src="buildLangFlag(lang)" alt="">
                <div class="uta-lang__current-code">{{ lang }}</div>
                <div class="uta-lang__current-arrow" :class="{ 'uta-lang__current-arrow--opened' : showLangList }">
                    <span class="material-icons">
                        expand_more
                    </span>
                </div>
            </div>
            <div class="uta-lang__choose" :class="{ 'uta-lang__choose--show' : showLangList }">
                <ul class="uta-lang__choose-list" id="UTALanguageChooseList">
                    <template v-for="(language, index) in languages" :key="index">
                        <li
                            class="uta-lang__choose-list-item" 
                            v-if="language != currentLanguage"
                            :data-code="language" 
                            @click="changeLang($event, language)"
                        >
                            <img class="uta-lang__choose-list-item-flag" :src="buildLangFlag(language)" alt="">
                            <div class="uta-lang__choose-list-item-code">{{ language }}</div>
                        </li>
                    </template>
                </ul>
            </div>
        </div>
        <div class="uta-lang__mobile btn-group" role="group" aria-label="Basic radio toggle button group">
            <button 
                type="radio" 
                class="uta-lang__mobile-btn btn btn-primary" 
                :class="{ 'uta-lang__mobile-btn--active' : language == lang }"
                name="UTALanguageInput" 
                v-for="(language, index) in languages" 
                :key="index"
                :id="`UTALanguageInput-${index}`" 
                @click="changeLang($event, language)"
            >
                <img class="uta-lang__choose-list-item-flag" :src="buildLangFlag(language)" alt="">
            </button>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute } from 'vue-router'
import { useLangStore } from '@/stores/lang'
import { useTranslaterStore } from '@/stores/translater'
import { useProfileStore } from '@/stores/profile'
import { useConfigStore } from '@/stores/config'
import setPageTitle from '@/helpers/setPageTitle'
import langFlagRu from '@/assets/images/icons/lang/RU.png'
import langFlagEn from '@/assets/images/icons/lang/EN.png'

const route = useRoute()
const langStore = useLangStore()
const configStore = useConfigStore()
const translaterStore = useTranslaterStore()
const profileStore = useProfileStore()

const lang = computed(() => langStore.lang)
const getTranslate = computed(() => translaterStore.getTranslate)
const profile = computed(() => profileStore.profile)

const setLang = langStore.setLang
const appName = configStore.appName

const currentLanguage = ref(lang.value)
const showLangList = ref(false) 
const languages = ['RU', 'EN']

function changeLang(event, language) {

    showLangList.value = false
    setLang(language)
}

function clickListener(event) {
    if(
        showLangList.value && 
        !event.target.classList.contains('uta-lang__current') && 
        !event.target.classList.contains('uta-lang__choose-list-item')
    ) {
        showLangList.value = false
    }
}

function buildLangFlag(code) {
    if(code == 'RU') return langFlagRu
    if(code == 'EN') return langFlagEn
}

onMounted(() => {
    document.addEventListener('click', clickListener())
})

watch(lang, code => {
    currentLanguage.value = code
    
    // Обновить title страницы
    if(route.name !== 'user-info' && route.name !== 'user-pass') {
        setPageTitle(route.meta.breadcrumbs)
    } else {
        if(profile.value.uuid !== route.params.uuid) {
            setPageTitle(route.meta.breadcrumbs)
        } else {
            document.title = getTranslate.value.MENU_PROFILE + ' - ' + appName
        }
    }
})

</script>

<style lang="scss">
@import '@/assets/styles/scss/components/lang';
</style>